import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		height: "100%",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		gap: tokens.spacingHorizontalL,
	},
	logo: {
		width: "192px",
	},
	contactUrl: {
		margin: "0 0 200px 0",
		color: tokens.colorBrandForegroundLink
	},
	tenantsContainer: {
		maxWidth: "400px",
		width: "400px",
		boxShadow: tokens.shadow16,
		color: tokens.colorNeutralForeground1,
		backgroundColor: tokens.colorNeutralBackground1,
		marginBottom: "20px",
		gap: tokens.spacingHorizontalM,
		padding: "30px 20px",
	},
	signinButton: {
		lineHeight: "30px",
		fontSize: "16px",
		height: "40px",
	},
	errorText: {
		color: tokens.colorStatusDangerForeground1,
	}
});
